// extracted by mini-css-extract-plugin
export default {"accept_nft_box":"StakeAssets_accept_nft_box__Bhogc","asset":"StakeAssets_asset__fcqYp","selected_asset":"StakeAssets_selected_asset__9YWWt"};